<template>
  <div
    v-if="displayedGoals && displayedGoals.length > 0"
    class="goals-selector-v4">
    <p
      v-if="isTitleVisible"
      class="goals-selector-v4__title"
    >
      Цель
    </p>
    <div class="goals-selector-v4__buttons">
      <CoreButton
        v-for="goal in displayedGoals"
        :key="goal.id"
        class="goals-selector-v4__btn"
        w100
        :type="getButtonType(goal.code)"
        @click="clickGoal(goal.code)"
      >
        {{ getGoalTitle(goal) }}
      </CoreButton>
    </div>
  </div>
</template>

<script>
import CoreButton from '@/components/core/ui/CoreButton'
import { mapGetters } from 'vuex'

const GOAL_CODES = ['medium', 'high']

export default {
  name: 'GoalsSelector',

  components: {
    CoreButton,
  },

  props: {
    isTitleVisible: {
      type: Boolean,
      default: true,
    },
    customText: {
      type: Array,
      default: () => ([]),
    },
  },

  emits: ['selectGoal'],

  data () {
    return {
      selectedGoalCode: GOAL_CODES[0],
    }
  },

  computed: {
    ...mapGetters('goals', ['goals']),

    displayedGoals () {
      const goals = this.goals?.filter(goal => goal.id !== 1) || []
      if (this.customText) {
        return this.customText.map(textInfo => {
          return this.goals.find(goal => goal.code === textInfo.goalCode)
        })
      }
      return goals.length ? goals : this.goals?.filter(goal => goal.id === 1)
    },

    selectedGoal () {
      return this.displayedGoals?.find((goal) => goal.code === this.selectedGoalCode)
    },
  },

  watch: {
    selectedGoal: {
      handler (value, olValue) {
        if (value?.code !== olValue?.code) {
          this.$emit('selectGoal', value)
        }
      },
      immediate: true,
    },
  },

  created () {
    this.selectedGoalCode = this.displayedGoals[0]?.code
  },

  mounted () {
    this.selectGoalByRouteParam()
  },

  methods: {
    getButtonType (goalCode) {
      if (goalCode === this.selectedGoalCode) {
        return
      }
      return 'white-grey'
    },

    getGoalTitle (goal) {
      if (this.customText) {
        const textInfo = this.customText.find(textInfo => textInfo.goalCode === goal.code)
        if (textInfo) {
          return textInfo.title
        }
      }
      return goal.title
    },

    selectGoalByRouteParam () {
      const routeGoalCode = this.$route.params.goal
      if (GOAL_CODES.includes(routeGoalCode)) {
        this.selectedGoalCode = routeGoalCode
      }
      this.clickGoal(this.selectedGoalCode)
    },

    async clickGoal (goalCode) {
      this.sendGTMMarkupEvent({
        block: 'new_order',
        element: 'target',
        action: 'change',
      })
      const navigationResult = await this.$router.replace({
        ...this.$route,
        params: {
          ...this.$route.params,
          goal: goalCode,
        },
      })

      if (!navigationResult) {
        this.selectedGoalCode = goalCode
      }
    },
  },
}
</script>

<style lang="scss">
.goals-selector-v4 {
  padding: 32px 0;

  &__title {
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
    padding-bottom: 16px;
  }

  &__buttons {
    display: flex;
    justify-content: space-between;
    column-gap: 8px;
  }

  &__btn {
    min-height: 48px;
    max-height: 48px;
    border-radius: 16px;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    padding: 0;
    text-transform: none;
  }
}
</style>
